<template>
    <v-footer app>

    </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data: () => ({
    
  }),
}
</script>